/* eslint-disable */
import { Route, Switch } from 'react-router-dom';

import {
  HomePage,
  SettingsPage,
  LogInPage,
  SignUpPage,
  QuestionsPage,
  LikesPage,
  PostDetailPage,
  NotFoundPage,
  NotificationsPage,
} from '../pages';
import { PrivateRoute, PreventedRoute } from './utils';
import { DefaultTemplate } from '../components/templates';

const preventedRoutes = [
  {
    name: 'signup',
    path: '/signup',
    component: SignUpPage,
  },
  {
    name: 'login',
    path: '/login',
    component: LogInPage,
  },
];

const privateRoutes = [
  {
    name: 'home',
    path: '/',
    component: HomePage,
  },
  {
    name: 'settings',
    path: '/settings',
    component: SettingsPage,
  },
  {
    name: 'questions',
    path: '/questions',
    component: QuestionsPage,
  },
  {
    name: 'likes',
    path: '/likes',
    component: LikesPage,
  },
  {
    name: 'detail',
    path: '/question/:postId',
    component: PostDetailPage,
  },
  {
    name: 'notifications',
    path: '/notifications',
    component: NotificationsPage,
  },
];

const Router = () => {
  return (
    <Switch>
      {privateRoutes.map(({ name, path, component }) => (
        <PrivateRoute key={name} path={path} component={component} exact />
      ))}
      {preventedRoutes.map(({ name, path, component }) => (
        <PreventedRoute key={name} path={path} component={component} exact />
      ))}
      <Route path="*">
        <DefaultTemplate>
          <NotFoundPage />
        </DefaultTemplate>
      </Route>
    </Switch>
  );
};

export default Router;
